import React from "react";
import ForgottenUserData from "../../ForgottenUserData";
import { forgottenUsername } from "../../../../../../axios/api/services";

const ForgottenUsername = () => {
  return (
    <ForgottenUserData
      captchaAction={"PortalForgottenUsernameSubmit"}
      serviceFn={forgottenUsername}
      successMessage={"m.forgotten.username.email.success"}
      pageTitle={"t.page.forgotten.username"}
      submitMessage={"l.btn.submit"}
    />
  );
};
export default ForgottenUsername;
